// extracted by mini-css-extract-plugin
export default {"carouselSlide":"_2DSmS1L5"};